export default __webpack_public_path__ + "static/media/seat-lounger-unavailable.be6aa908.svg";